import { useQuery } from '@apollo/client';
import { Skeleton } from 'antd';
import { GET_TREEVIEW_DATA } from 'graphql/queries/contentLibraryQueries';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import FolderIcon from 'components/Icons/FolderIcon';
import RightIcon from 'components/Icons/RightIcon';
import StarIcon from 'components/Icons/StarIcon';
import useTreeHandler from 'hooks/treeHandler';

import './LibraryFolderList.scss';

/**
 * LibraryFolderList component
 * @param {Object} props - The component props
 * @param {string} props.type - The type
 * @param {string} props.selectedFolder - The selected folder
 * @param {Function} props.setSelectedFolder - The set selected folder function
 * @returns {JSX.Element} The LibraryFolderList component
 */
const LibraryFolderList = ({ type, selectedFolder = '', setSelectedFolder }) => {
  const [currentFolderData, setCurrentFolderData] = useState([]);

  const { addKey } = useTreeHandler();
  const { data, loading } = useQuery(GET_TREEVIEW_DATA, {
    variables: {
      type,
    },
  });

  useEffect(() => {
    (async () => {
      if (data && data.fetchContentLibrary) {
        let newData = JSON.parse(JSON.stringify(data.fetchContentLibrary));
        newData.key = '';
        addKey(newData);
        setCurrentFolderData(newData.children);
      } else {
        setCurrentFolderData([]);
      }
    })();
  }, [selectedFolder, data, setCurrentFolderData, addKey]);

  return (
    <div className="gallery-library-folders">
      {loading ? (
        <Skeleton
          active
          style={{
            marginTop: '16px',
          }}
          title={false}
          paragraph={{
            rows: 4, // Number of rows
            width: ['50%', '50%', '50%', '50%'], // Ensure equal width for each row
          }}
        />
      ) : (
        <>
          <>
            {type === 'medias' && (
              <div
                className={`folder ${selectedFolder === 'all' ? 'folder-selected' : ''}`}
                onClick={() => setSelectedFolder('all')}>
                <FolderIcon />
                <span className="folder-name">All Folder</span>
                <RightIcon color="#7876C1" />
              </div>
            )}
            {type !== 'medias' && (
              <>
                <div className="folder" onClick={() => setSelectedFolder(`shared-folder`)}>
                  <FolderIcon />
                  <span className="folder-name">All Shared</span>
                  <RightIcon color="#7876C1" />
                </div>
              </>
            )}
            <div
              className={`folder ${selectedFolder === 'all-starred' ? 'folder-selected' : ''}`}
              onClick={() => setSelectedFolder(`all-starred`)}>
              <StarIcon className="star-icon" />
              <span className="folder-name">All Starred</span>
              <RightIcon color="#7876C1" />
            </div>
          </>
          {currentFolderData.length > 0 &&
            currentFolderData.map((folder, i) => (
              <div
                key={i}
                className={`folder ${selectedFolder === folder.path ? 'folder-selected' : ''}`}
                onClick={() => setSelectedFolder(folder.path)}>
                <FolderIcon />
                <span className="folder-name">{folder.title}</span>
                <RightIcon color="#7876C1" />
              </div>
            ))}
        </>
      )}
    </div>
  );
};

LibraryFolderList.defaultProps = {
  type: '',
  selectedFolder: '',
  setSelectedFolder: () => {},
};

LibraryFolderList.propTypes = {
  type: PropTypes.string,
  selectedFolder: PropTypes.string,
  setSelectedFolder: PropTypes.func,
};

export default LibraryFolderList;
